import React from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

function LegalItem({ number, children }) {
  return (
    <div className="legal-item">
      <span className="legal-item-number">
        {number}
      </span>

      <div className="legal-item-content">
        {children}
      </div>
    </div>
  );
}

function SubTitle({ children }) {
  return (
    <h3 className="legal-subtitle">
      {children}
    </h3>
  );
}

export default function Terms() {
  return (
    <main className="legal-page">
      <style>{styles}</style>

      <SiteHeader />

      {/* =====================================================
          PAGE TITLE
         ===================================================== */}

      <header className="legal-header">
        <div className="legal-wrap">
          <h1>使用條款</h1>
        </div>
      </header>

      {/* =====================================================
          CONTENT
         ===================================================== */}

      <div className="legal-wrap legal-layout">
        <article className="legal-content">

          {/* =====================================================
              第一條
             ===================================================== */}

          <section className="legal-section">
            <div className="legal-section-heading">
              <span>第一條</span>

              <h2>
                適用範圍
              </h2>
            </div>

            <p className="legal-body-paragraph">
              本使用條款適用於您使用 TALLARGE
              提供的任何相關軟體、應用程式、網站及其他相關服務
              （以下統稱「本服務」）。
            </p>

            <p className="legal-body-paragraph">
              TALLARGE 是由 張庭瑋 及 陳 煜
              共同經營並提供相關服務的品牌
              （以下簡稱「我們」、「TALLARGE」）。
              當您註冊、登入、下載或開始使用本服務，
              即表示您已閱讀、瞭解並同意遵守本使用條款。
            </p>
          </section>

          {/* =====================================================
              第二條
             ===================================================== */}

          <section className="legal-section">
            <div className="legal-section-heading">
              <span>第二條</span>

              <h2>
                名詞定義
              </h2>
            </div>

            <p className="legal-body-paragraph">
              本條款所使用之名詞，定義如下：
            </p>
          </section>

          {/* =====================================================
              第三條
             ===================================================== */}

          <section className="legal-section">
            <div className="legal-section-heading">
              <span>第三條</span>

              <h2>
                帳號註冊及安全性
              </h2>
            </div>

            <LegalItem number="一、">
              <p>
                使用者註冊或啟用 TALLARGE 帳號時，
                應提供正確且完整的資料，
                並在個人資料變更後及時更新。
                使用者不得與他人共用帳號、
                密碼或其他登入資料，
                也不得將帳號交由他人使用。
                使用者應對透過其帳號完成的任何操作負責。
              </p>
            </LegalItem>

            <LegalItem number="二、">
              <p>
                使用者發現帳號遭冒用、
                密碼外洩或其他安全問題時，
                應立即通知本服務提供者並變更密碼。
              </p>
            </LegalItem>

            <LegalItem number="三、">
              <p>
                為保護帳號、系統或資料安全，
                TALLARGE 可以要求使用者重新驗證身分、
                重設密碼或暫時限制帳號登入，
                並將處理結果通知受影響的使用者。
              </p>
            </LegalItem>
          </section>

          {/* =====================================================
              第四條
             ===================================================== */}

          <section className="legal-section">
            <div className="legal-section-heading">
              <span>第四條</span>

              <h2>
                使用本服務
              </h2>
            </div>

            <SubTitle>
              一、使用本服務
            </SubTitle>

            <p className="legal-body-paragraph">
              使用者遵守本條款及相關法令時，
              可以在取得授權的範圍內存取及使用本服務。
              使用者使用本服務時，
              也應遵守相關操作說明、安全要求及功能規則。
            </p>

            <SubTitle>
              二、軟體授權
            </SubTitle>

            <p className="legal-body-paragraph">
              TALLARGE 僅授予使用者有限、非專屬、
              不可轉讓且不得再授權之本服務使用權。
              使用者只能在帳號有效及取得授權的期間內，
              使用本服務為所屬企業執行工作。
              本服務係以授權／訂閱方式提供，
              並非買賣或買斷；
              使用者不會因下載或使用該等軟體，
              而取得軟體本身或其相關智慧財產權的所有權，
              其任何相關權利仍歸 TALLARGE
              及其經營人所有。
            </p>

            <SubTitle>
              三、禁止事項
            </SubTitle>

            <p className="legal-body-paragraph">
              使用者不得將本服務用於任何違法、
              侵權、危害他人或妨礙系統運作的行為，包括：
            </p>

            <div className="numbered-list">
              <LegalItem number="1.">
                <p>
                  反向工程、破解、規避技術或計費限制。
                </p>
              </LegalItem>

              <LegalItem number="2.">
                <p>
                  嘗試取得未公開之原始碼、
                  憑證或系統權限。
                </p>
              </LegalItem>

              <LegalItem number="3.">
                <p>
                  未經授權進行弱點掃描、
                  滲透測試或其他安全測試。
                </p>
              </LegalItem>

              <LegalItem number="4.">
                <p>
                  干擾系統、散布惡意程式
                  或大量自動抓取資料。
                </p>
              </LegalItem>

              <LegalItem number="5.">
                <p>
                  出售、出租、分租或轉售
                  TALLARGE 帳號或服務。
                </p>
              </LegalItem>

              <LegalItem number="6.">
                <p>
                  利用本服務從事違法、詐欺、
                  侵權、騷擾或其他不法行為。
                </p>
              </LegalItem>

              <LegalItem number="7.">
                <p>
                  利用定位、照片、電子簽名、
                  聯絡人或通訊功能從事非法監控。
                </p>
              </LegalItem>

              <LegalItem number="8.">
                <p>
                  侵害第三人之隱私權、人格權、
                  智慧財產權、營業秘密或其他權利。
                </p>
              </LegalItem>

              <LegalItem number="9.">
                <p>
                  其他可能對 Tallarge、
                  其他客戶或第三人造成重大安全
                  或法律風險之行為。
                </p>
              </LegalItem>
            </div>

            <SubTitle>
              四、第三方服務
            </SubTitle>

            <LegalItem number="1.">
              <p>
                本服務可能包含第三方提供的任何相關軟體、
                應用程式、網站及其他相關服務
                （以下稱「第三方服務」）。
                第三方服務之使用及相關權利義務，
                依其提供者之適用條款所約束，
                您將自行承受使用第三方服務之相關風險與責任。
              </p>
            </LegalItem>

            <LegalItem number="2.">
              <p>
                第三方服務可能受到網路、裝置、
                GPS 訊號、地理環境或供應商系統等因素影響，
                因此不保證其永久不中斷或完全無誤。
                我們得基於營運、技術、資安或服務品質需要，
                選用、更換或停止使用第三方服務。
              </p>
            </LegalItem>
          </section>

          {/* =====================================================
              第五條
             ===================================================== */}

          <section className="legal-section">
            <div className="legal-section-heading">
              <span>第五條</span>

              <h2>
                智慧財產權
              </h2>
            </div>

            <LegalItem number="一、">
              <div>
                <strong>
                  著作權
                </strong>

                <p>
                  TALLARGE 所提供的系統、軟體、
                  應用程式（App）、網站、系統介面、
                  畫面設計（含 UI/UX 設計稿、原型及轉場動畫）、
                  程式（含原始碼、目的碼、API 及演算法）、
                  文件（含規格書、流程圖、手冊）、
                  資料庫（含資料庫結構與欄位設計）、
                  文字、圖片、圖示、影音（含音效、配樂）、
                  功能、中介資料、衍生數據、
                  專案相關之字型及其他內容，
                  以及上述各項之修改、升級、改版或衍生著作，
                  不論其儲存媒介或呈現形式為何，
                  其著作權均屬 TALLARGE
                  及其代表自然人所有。
                  使用者僅得於本條款約定之授權及範圍內使用本服務，
                  此項授權不構成任何權利之出售或讓與，
                  亦不因此取得本服務內容之著作權。
                  未經 TALLARGE 事前書面同意，
                  使用者不得複製、修改、改作、重製、
                  公開傳輸、散布、出租、出售、
                  轉售或提供他人使用。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="二、">
              <div>
                <strong>
                  商標權
                </strong>

                <p>
                  TALLARGE 的名稱、商標
                  （含文字、圖形、記號、顏色、
                  立體形狀、聲音、動態及全像圖商標）、
                  標誌、服務名稱、網域名稱、
                  社群媒體帳號名稱、廣告標語、
                  商品包裝及營業外觀、吉祥物、
                  應用程式名稱、圖示及其他現在或未來
                  具備識別性之商業標誌。，
                  均屬 TALLARGE 及其代表自然人所有。
                  除本條款明確允許或經 TALLARGE
                  事前書面同意外，
                  使用者不得使用、複製、修改、
                  註冊、申請註冊、移除或仿冒
                  TALLARGE 的商標、標誌或其他識別標誌，
                  也不得以任何方式表示使用者與
                  TALLARGE 之間具有代理、合夥、
                  加盟、背書或其他未經授權的關係。
                </p>
              </div>
            </LegalItem>
          </section>

        </article>
      </div>

      <SiteFooter />
    </main>
  );
}

const styles = `
* {
  box-sizing: border-box;
}

.legal-page {
  min-height: 100vh;

  display: flex;
  flex-direction: column;

  background: #fff;

  color: #22272c;

  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "SF Pro Text",
    "SF Pro Display",
    "PingFang TC",
    "Noto Sans TC",
    "Microsoft JhengHei",
    Arial,
    sans-serif;

  -webkit-font-smoothing: antialiased;
}

.legal-wrap {
  width:
    min(
      900px,
      calc(
        100% - 48px
      )
    );

  margin: 0 auto;
}


/* =========================================================
   HEADER
   ========================================================= */

.legal-header {
  padding:
    52px 0
    42px;

  border-bottom:
    1px solid
    #eeeeec;
}

.legal-header h1 {
  margin: 0;

  color: #20252a;

  font-size:
    clamp(
      30px,
      3vw,
      40px
    );

  font-weight: 600;

  line-height: 1.2;

  letter-spacing:
    -.04em;
}


/* =========================================================
   LAYOUT
   ========================================================= */

.legal-layout {
  flex: 1;

  padding:
    58px 0
    100px;
}

.legal-content {
  width: 100%;
}


/* =========================================================
   SECTIONS
   ========================================================= */

.legal-section {
  padding-bottom: 62px;

  margin-bottom: 62px;

  border-bottom:
    1px solid
    #eeeeec;
}

.legal-section-heading {
  margin-bottom: 30px;
}

.legal-section-heading > span {
  display: block;

  margin-bottom: 8px;

  color: #555c62;

  font-size: 12px;

  font-weight: 500;
}

.legal-section-heading h2 {
  margin: 0;

  color: #22272c;

  font-size:
    clamp(
      22px,
      2vw,
      28px
    );

  font-weight: 600;

  line-height: 1.4;

  letter-spacing:
    -.025em;
}

.legal-body-paragraph {
  margin:
    0 0
    22px;

  color: #555d64;

  font-size: 14px;

  line-height: 2;
}


/* =========================================================
   SUBTITLE
   ========================================================= */

.legal-subtitle {
  margin:
    38px 0
    19px;

  color: #30363b;

  font-size: 16px;

  font-weight: 600;

  line-height: 1.6;
}


/* =========================================================
   ITEM
   ========================================================= */

.legal-item {
  display: grid;

  grid-template-columns:
    58px
    minmax(
      0,
      1fr
    );

  gap: 8px;

  margin-top: 22px;
}

.legal-item-number {
  padding-top: 2px;

  color: #777e84;

  font-size: 13px;

  line-height: 1.95;
}

.legal-item-content {
  min-width: 0;
}

.legal-item-content strong {
  display: block;

  margin-bottom: 5px;

  color: #343a40;

  font-size: 14px;

  font-weight: 600;

  line-height: 1.8;
}

.legal-item-content p {
  margin: 0;

  color: #555d64;

  font-size: 14px;

  line-height: 2;
}

.numbered-list {
  margin-bottom: 32px;
}


/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 620px) {
  .legal-wrap {
    width:
      calc(
        100% - 34px
      );
  }

  .legal-header {
    padding:
      38px 0
      30px;
  }

  .legal-header h1 {
    font-size: 29px;
  }

  .legal-layout {
    padding:
      42px 0
      70px;
  }

  .legal-section {
    padding-bottom: 48px;

    margin-bottom: 48px;
  }

  .legal-section-heading {
    margin-bottom: 24px;
  }

  .legal-section-heading h2 {
    font-size: 22px;
  }

  .legal-item {
    grid-template-columns:
      44px
      minmax(
        0,
        1fr
      );
  }

  .legal-item-content p,
  .legal-body-paragraph {
    font-size: 13px;

    line-height: 1.95;
  }
}
`;